/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionFlowRequestDTO,
  GetCompletedRequestsParams,
  GetMyRequestsParams,
  GetMyReturnedRequestsParams,
  GetPendingActionFlowRequestsParams,
  GetPendingRequestsToApproveParams,
  GetRequestsParams,
  ResponseData,
  WorkFlowApprovalRequest,
  WorkFlowResendRequest
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const resendNotification = (
    id: string,
    workFlowResendRequest: WorkFlowResendRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResponseData>(
      {url: `/api/v1/action-flows/${id}/resend`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workFlowResendRequest, signal
    },
      options);
    }
  


export const getResendNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendNotification>>, TError,{id: string;data: WorkFlowResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendNotification>>, TError,{id: string;data: WorkFlowResendRequest}, TContext> => {

const mutationKey = ['resendNotification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendNotification>>, {id: string;data: WorkFlowResendRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  resendNotification(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendNotification>>>
    export type ResendNotificationMutationBody = WorkFlowResendRequest
    export type ResendNotificationMutationError = unknown

    export const useResendNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendNotification>>, TError,{id: string;data: WorkFlowResendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendNotification>>,
        TError,
        {id: string;data: WorkFlowResendRequest},
        TContext
      > => {

      const mutationOptions = getResendNotificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const approve = (
    id: string,
    workFlowApprovalRequest: WorkFlowApprovalRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResponseData>(
      {url: `/api/v1/action-flows/${id}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workFlowApprovalRequest, signal
    },
      options);
    }
  


export const getApproveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{id: string;data: WorkFlowApprovalRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{id: string;data: WorkFlowApprovalRequest}, TContext> => {

const mutationKey = ['approve'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approve>>, {id: string;data: WorkFlowApprovalRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  approve(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveMutationResult = NonNullable<Awaited<ReturnType<typeof approve>>>
    export type ApproveMutationBody = WorkFlowApprovalRequest
    export type ApproveMutationError = unknown

    export const useApprove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{id: string;data: WorkFlowApprovalRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approve>>,
        TError,
        {id: string;data: WorkFlowApprovalRequest},
        TContext
      > => {

      const mutationOptions = getApproveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get  action flow requests
 */
export const getRequests = (
    params: GetRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetRequestsInfiniteQueryKey = (params?: GetRequestsParams,) => {
    return [
    'infinite', `/api/v1/action-flows`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetRequestsQueryKey = (params?: GetRequestsParams,) => {
    return [
    `/api/v1/action-flows`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getRequests>>>, TError = unknown>(params: GetRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequests>>> = ({ signal }) => getRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRequests>>>
export type GetRequestsInfiniteQueryError = unknown


export function useGetRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequests>>>, TError = unknown>(
 params: GetRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequests>>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequests>>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get  action flow requests
 */

export function useGetRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRequests>>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getRequests>>, TError = unknown>(params: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequests>>> = ({ signal }) => getRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequests>>>
export type GetRequestsQueryError = unknown


export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = unknown>(
 params: GetRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequests>>,
          TError,
          Awaited<ReturnType<typeof getRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get  action flow requests
 */

export function useGetRequests<TData = Awaited<ReturnType<typeof getRequests>>, TError = unknown>(
 params: GetRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get pending  action flow by scope ID
 */
export const getToApprove = (
    scopeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO>(
      {url: `/api/v1/action-flows/${scopeId}/to-approve`, method: 'GET', signal
    },
      options);
    }
  



export const getGetToApproveInfiniteQueryKey = (scopeId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/${scopeId}/to-approve`
    ] as const;
    }

export const getGetToApproveQueryKey = (scopeId?: string,) => {
    return [
    `/api/v1/action-flows/${scopeId}/to-approve`
    ] as const;
    }

    
export const getGetToApproveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getToApprove>>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetToApproveInfiniteQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToApprove>>> = ({ signal }) => getToApprove(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetToApproveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getToApprove>>>
export type GetToApproveInfiniteQueryError = unknown


export function useGetToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getToApprove>>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToApprove>>,
          TError,
          Awaited<ReturnType<typeof getToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getToApprove>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToApprove>>,
          TError,
          Awaited<ReturnType<typeof getToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getToApprove>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending  action flow by scope ID
 */

export function useGetToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getToApprove>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetToApproveInfiniteQueryOptions(scopeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetToApproveQueryOptions = <TData = Awaited<ReturnType<typeof getToApprove>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetToApproveQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToApprove>>> = ({ signal }) => getToApprove(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetToApproveQueryResult = NonNullable<Awaited<ReturnType<typeof getToApprove>>>
export type GetToApproveQueryError = unknown


export function useGetToApprove<TData = Awaited<ReturnType<typeof getToApprove>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToApprove>>,
          TError,
          Awaited<ReturnType<typeof getToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetToApprove<TData = Awaited<ReturnType<typeof getToApprove>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToApprove>>,
          TError,
          Awaited<ReturnType<typeof getToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetToApprove<TData = Awaited<ReturnType<typeof getToApprove>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending  action flow by scope ID
 */

export function useGetToApprove<TData = Awaited<ReturnType<typeof getToApprove>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetToApproveQueryOptions(scopeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get pending  action flow by scope ID
 */
export const getPendingActionFlowByScopeId = (
    scopeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO>(
      {url: `/api/v1/action-flows/${scopeId}/pending`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPendingActionFlowByScopeIdInfiniteQueryKey = (scopeId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/${scopeId}/pending`
    ] as const;
    }

export const getGetPendingActionFlowByScopeIdQueryKey = (scopeId?: string,) => {
    return [
    `/api/v1/action-flows/${scopeId}/pending`
    ] as const;
    }

    
export const getGetPendingActionFlowByScopeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingActionFlowByScopeIdInfiniteQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>> = ({ signal }) => getPendingActionFlowByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingActionFlowByScopeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>
export type GetPendingActionFlowByScopeIdInfiniteQueryError = unknown


export function useGetPendingActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending  action flow by scope ID
 */

export function useGetPendingActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingActionFlowByScopeIdInfiniteQueryOptions(scopeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingActionFlowByScopeIdQueryOptions = <TData = Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingActionFlowByScopeIdQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>> = ({ signal }) => getPendingActionFlowByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingActionFlowByScopeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>>
export type GetPendingActionFlowByScopeIdQueryError = unknown


export function useGetPendingActionFlowByScopeId<TData = Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowByScopeId<TData = Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowByScopeId<TData = Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending  action flow by scope ID
 */

export function useGetPendingActionFlowByScopeId<TData = Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingActionFlowByScopeIdQueryOptions(scopeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get action flow by scope ID
 */
export const getActionFlowByScopeId = (
    scopeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO>(
      {url: `/api/v1/action-flows/scope/${scopeId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetActionFlowByScopeIdInfiniteQueryKey = (scopeId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/scope/${scopeId}`
    ] as const;
    }

export const getGetActionFlowByScopeIdQueryKey = (scopeId?: string,) => {
    return [
    `/api/v1/action-flows/scope/${scopeId}`
    ] as const;
    }

    
export const getGetActionFlowByScopeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowByScopeId>>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowByScopeIdInfiniteQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowByScopeId>>> = ({ signal }) => getActionFlowByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowByScopeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowByScopeId>>>
export type GetActionFlowByScopeIdInfiniteQueryError = unknown


export function useGetActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get action flow by scope ID
 */

export function useGetActionFlowByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActionFlowByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowByScopeIdInfiniteQueryOptions(scopeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetActionFlowByScopeIdQueryOptions = <TData = Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionFlowByScopeIdQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionFlowByScopeId>>> = ({ signal }) => getActionFlowByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionFlowByScopeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getActionFlowByScopeId>>>
export type GetActionFlowByScopeIdQueryError = unknown


export function useGetActionFlowByScopeId<TData = Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowByScopeId<TData = Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionFlowByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getActionFlowByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionFlowByScopeId<TData = Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get action flow by scope ID
 */

export function useGetActionFlowByScopeId<TData = Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionFlowByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionFlowByScopeIdQueryOptions(scopeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get pending action flow requests
 */
export const getPendingActionFlowRequests = (
    params: GetPendingActionFlowRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows/pending`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPendingActionFlowRequestsInfiniteQueryKey = (params?: GetPendingActionFlowRequestsParams,) => {
    return [
    'infinite', `/api/v1/action-flows/pending`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPendingActionFlowRequestsQueryKey = (params?: GetPendingActionFlowRequestsParams,) => {
    return [
    `/api/v1/action-flows/pending`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPendingActionFlowRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>, TError = unknown>(params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingActionFlowRequestsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingActionFlowRequests>>> = ({ signal }) => getPendingActionFlowRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingActionFlowRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>
export type GetPendingActionFlowRequestsInfiniteQueryError = unknown


export function useGetPendingActionFlowRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending action flow requests
 */

export function useGetPendingActionFlowRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingActionFlowRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingActionFlowRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError = unknown>(params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingActionFlowRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingActionFlowRequests>>> = ({ signal }) => getPendingActionFlowRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingActionFlowRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingActionFlowRequests>>>
export type GetPendingActionFlowRequestsQueryError = unknown


export function useGetPendingActionFlowRequests<TData = Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowRequests<TData = Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>,
          TError,
          Awaited<ReturnType<typeof getPendingActionFlowRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingActionFlowRequests<TData = Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending action flow requests
 */

export function useGetPendingActionFlowRequests<TData = Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError = unknown>(
 params: GetPendingActionFlowRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingActionFlowRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingActionFlowRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get pending action flow requests to approve
 */
export const getPendingRequestsToApprove = (
    params: GetPendingRequestsToApproveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows/pending-to-approve`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPendingRequestsToApproveInfiniteQueryKey = (params?: GetPendingRequestsToApproveParams,) => {
    return [
    'infinite', `/api/v1/action-flows/pending-to-approve`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPendingRequestsToApproveQueryKey = (params?: GetPendingRequestsToApproveParams,) => {
    return [
    `/api/v1/action-flows/pending-to-approve`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPendingRequestsToApproveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>, TError = unknown>(params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingRequestsToApproveInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingRequestsToApprove>>> = ({ signal }) => getPendingRequestsToApprove(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingRequestsToApproveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>
export type GetPendingRequestsToApproveInfiniteQueryError = unknown


export function useGetPendingRequestsToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>,
          TError,
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingRequestsToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>,
          TError,
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingRequestsToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending action flow requests to approve
 */

export function useGetPendingRequestsToApproveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingRequestsToApproveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPendingRequestsToApproveQueryOptions = <TData = Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError = unknown>(params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingRequestsToApproveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingRequestsToApprove>>> = ({ signal }) => getPendingRequestsToApprove(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingRequestsToApproveQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingRequestsToApprove>>>
export type GetPendingRequestsToApproveQueryError = unknown


export function useGetPendingRequestsToApprove<TData = Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>,
          TError,
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingRequestsToApprove<TData = Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>,
          TError,
          Awaited<ReturnType<typeof getPendingRequestsToApprove>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingRequestsToApprove<TData = Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get pending action flow requests to approve
 */

export function useGetPendingRequestsToApprove<TData = Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError = unknown>(
 params: GetPendingRequestsToApproveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingRequestsToApprove>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingRequestsToApproveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns requests that have been returned to the current user for revision
 * @summary Get returned action flow requests for the current maker
 */
export const getMyReturnedRequests = (
    params: GetMyReturnedRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows/my-returned-requests`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMyReturnedRequestsInfiniteQueryKey = (params?: GetMyReturnedRequestsParams,) => {
    return [
    'infinite', `/api/v1/action-flows/my-returned-requests`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetMyReturnedRequestsQueryKey = (params?: GetMyReturnedRequestsParams,) => {
    return [
    `/api/v1/action-flows/my-returned-requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyReturnedRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMyReturnedRequests>>>, TError = unknown>(params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReturnedRequestsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReturnedRequests>>> = ({ signal }) => getMyReturnedRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyReturnedRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReturnedRequests>>>
export type GetMyReturnedRequestsInfiniteQueryError = unknown


export function useGetMyReturnedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyReturnedRequests>>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReturnedRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyReturnedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyReturnedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyReturnedRequests>>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReturnedRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyReturnedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyReturnedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyReturnedRequests>>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get returned action flow requests for the current maker
 */

export function useGetMyReturnedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyReturnedRequests>>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyReturnedRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMyReturnedRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getMyReturnedRequests>>, TError = unknown>(params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReturnedRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReturnedRequests>>> = ({ signal }) => getMyReturnedRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyReturnedRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReturnedRequests>>>
export type GetMyReturnedRequestsQueryError = unknown


export function useGetMyReturnedRequests<TData = Awaited<ReturnType<typeof getMyReturnedRequests>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReturnedRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyReturnedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyReturnedRequests<TData = Awaited<ReturnType<typeof getMyReturnedRequests>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReturnedRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyReturnedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyReturnedRequests<TData = Awaited<ReturnType<typeof getMyReturnedRequests>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get returned action flow requests for the current maker
 */

export function useGetMyReturnedRequests<TData = Awaited<ReturnType<typeof getMyReturnedRequests>>, TError = unknown>(
 params: GetMyReturnedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReturnedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyReturnedRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get  action flow requests
 */
export const getMyRequests = (
    params: GetMyRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows/my-requests`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMyRequestsInfiniteQueryKey = (params?: GetMyRequestsParams,) => {
    return [
    'infinite', `/api/v1/action-flows/my-requests`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetMyRequestsQueryKey = (params?: GetMyRequestsParams,) => {
    return [
    `/api/v1/action-flows/my-requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMyRequests>>>, TError = unknown>(params: GetMyRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRequestsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRequests>>> = ({ signal }) => getMyRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRequests>>>
export type GetMyRequestsInfiniteQueryError = unknown


export function useGetMyRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequests>>>, TError = unknown>(
 params: GetMyRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequests>>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequests>>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get  action flow requests
 */

export function useGetMyRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequests>>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getMyRequests>>, TError = unknown>(params: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRequests>>> = ({ signal }) => getMyRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRequests>>>
export type GetMyRequestsQueryError = unknown


export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = unknown>(
 params: GetMyRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequests>>,
          TError,
          Awaited<ReturnType<typeof getMyRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get  action flow requests
 */

export function useGetMyRequests<TData = Awaited<ReturnType<typeof getMyRequests>>, TError = unknown>(
 params: GetMyRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get my action flow request by scope ID
 */
export const getMyRequestByScopeId = (
    scopeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO>(
      {url: `/api/v1/action-flows/my-requests/${scopeId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMyRequestByScopeIdInfiniteQueryKey = (scopeId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/my-requests/${scopeId}`
    ] as const;
    }

export const getGetMyRequestByScopeIdQueryKey = (scopeId?: string,) => {
    return [
    `/api/v1/action-flows/my-requests/${scopeId}`
    ] as const;
    }

    
export const getGetMyRequestByScopeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMyRequestByScopeId>>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRequestByScopeIdInfiniteQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRequestByScopeId>>> = ({ signal }) => getMyRequestByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyRequestByScopeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRequestByScopeId>>>
export type GetMyRequestByScopeIdInfiniteQueryError = unknown


export function useGetMyRequestByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequestByScopeId>>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequestByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getMyRequestByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequestByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequestByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getMyRequestByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequestByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get my action flow request by scope ID
 */

export function useGetMyRequestByScopeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMyRequestByScopeId>>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyRequestByScopeIdInfiniteQueryOptions(scopeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMyRequestByScopeIdQueryOptions = <TData = Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError = unknown>(scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyRequestByScopeIdQueryKey(scopeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyRequestByScopeId>>> = ({ signal }) => getMyRequestByScopeId(scopeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(scopeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyRequestByScopeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMyRequestByScopeId>>>
export type GetMyRequestByScopeIdQueryError = unknown


export function useGetMyRequestByScopeId<TData = Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError = unknown>(
 scopeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequestByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getMyRequestByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestByScopeId<TData = Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyRequestByScopeId>>,
          TError,
          Awaited<ReturnType<typeof getMyRequestByScopeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyRequestByScopeId<TData = Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get my action flow request by scope ID
 */

export function useGetMyRequestByScopeId<TData = Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError = unknown>(
 scopeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyRequestByScopeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyRequestByScopeIdQueryOptions(scopeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get completed action flow requests
 */
export const getCompletedRequests = (
    params: GetCompletedRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowRequestDTO[]>(
      {url: `/api/v1/action-flows/completed`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCompletedRequestsInfiniteQueryKey = (params?: GetCompletedRequestsParams,) => {
    return [
    'infinite', `/api/v1/action-flows/completed`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetCompletedRequestsQueryKey = (params?: GetCompletedRequestsParams,) => {
    return [
    `/api/v1/action-flows/completed`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCompletedRequestsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompletedRequests>>>, TError = unknown>(params: GetCompletedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompletedRequestsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompletedRequests>>> = ({ signal }) => getCompletedRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompletedRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompletedRequests>>>
export type GetCompletedRequestsInfiniteQueryError = unknown


export function useGetCompletedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompletedRequests>>>, TError = unknown>(
 params: GetCompletedRequestsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompletedRequests>>,
          TError,
          Awaited<ReturnType<typeof getCompletedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompletedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompletedRequests>>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompletedRequests>>,
          TError,
          Awaited<ReturnType<typeof getCompletedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompletedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompletedRequests>>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get completed action flow requests
 */

export function useGetCompletedRequestsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompletedRequests>>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompletedRequestsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCompletedRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getCompletedRequests>>, TError = unknown>(params: GetCompletedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompletedRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompletedRequests>>> = ({ signal }) => getCompletedRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompletedRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompletedRequests>>>
export type GetCompletedRequestsQueryError = unknown


export function useGetCompletedRequests<TData = Awaited<ReturnType<typeof getCompletedRequests>>, TError = unknown>(
 params: GetCompletedRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompletedRequests>>,
          TError,
          Awaited<ReturnType<typeof getCompletedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompletedRequests<TData = Awaited<ReturnType<typeof getCompletedRequests>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompletedRequests>>,
          TError,
          Awaited<ReturnType<typeof getCompletedRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompletedRequests<TData = Awaited<ReturnType<typeof getCompletedRequests>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get completed action flow requests
 */

export function useGetCompletedRequests<TData = Awaited<ReturnType<typeof getCompletedRequests>>, TError = unknown>(
 params: GetCompletedRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompletedRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompletedRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




